import { render } from "./EditPontajProiectDetail.vue?vue&type=template&id=3dcbe1d8&scoped=true&ts=true"
import script from "./EditPontajProiectDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditPontajProiectDetail.ts?vue&type=script&lang=ts&external"

import "./EditPontajProiectDetail.vue?vue&type=style&index=0&id=3dcbe1d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcbe1d8"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QForm,QField});
